import {
  Box,
  Grid,
  Tooltip,
  Button,
  Typography,
  ListItem,
  Stack,
  IconButton,
  TextField,
  Autocomplete,
} from "@mui/material/";

import "./importTransportationStyle.css";
import { useEffect, useState } from "react";

import { importTransportationPriceListActions } from "../../service/importtransportationpricelist.actions";

import { useTranslation } from "react-i18next";
import GenericFilterBox from "../common/GenericFilterBox";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { transformationActions } from "../../service/transformation.action";

export const ImportTransportationFilterAndSearch = (props: any) => {
  const refreshPage = props.refreshPage
  const setRefreshPage = props.setRefreshPage
  const resetFormTextImportTransportation = props.resetFormTextImportTransportation
  const dataFormSearchFieldImportTransportation = props.dataFormSearchFieldImportTransportation
  const setDataFormSearchFieldImportTransportation = props.setDataFormSearchFieldImportTransportation
  
  const [supplierArray, setSupplierArray] = useState<any>([]);
  const [statusArray, setStatusArray] = useState<any>([]);
  const transformationService = transformationActions();
  const { t } = useTranslation(["operation"]);
  
  async function getFilters() {
    transformationService.getSupplier(props.tenant).then((response: any) => {
      setSupplierArray(response.data);
    });
    importTransportationPriceListActions().getStatus().then((response: any) => {
      setStatusArray(response.data);
    });
  }
  const changeStatusName = (statusName: string) => {
    switch (statusName) {
      case "SUCCESS":
        return t("internOptionSelectName.statusType.success");
      case "PENDING":
        return t("internOptionSelectName.statusType.pending");
      case "WAITING":
        return t("internOptionSelectName.statusType.waiting");
      case "WITH_ERRORS_XLS_FORMAT":
        return t("internOptionSelectName.statusType.xlsError");
      case "WITH_ERRORS_SYNTAX":
        return t("internOptionSelectName.statusType.syntaxError");
      case "WITH_ERRORS_DATA_INTEGRITY":
        return t("internOptionSelectName.statusType.dataIntegrityError");
      case "WITH_ERRORS_GENERIC_ERROR":
        return t("internOptionSelectName.statusType.genericError");
      default:
        return "";
    }
  };
  const Search = (e: any) => {
    e.preventDefault();
    setRefreshPage(!refreshPage)
  };

  useEffect(() => {
    setDataFormSearchFieldImportTransportation({ ...dataFormSearchFieldImportTransportation, supplierId: {...dataFormSearchFieldImportTransportation?.supplierId, id :"", descr:""}});
    getFilters()
  }, [props.tenant]);
  return (
    <>
      <form id="importTransportationId" onSubmit={(e) => Search(e)}>
        <GenericFilterBox formId="importTransportationId" onReset={resetFormTextImportTransportation} showExtrasFilters={true}>
      
       <Box>
      
       
                 
       <Autocomplete
       disablePortal
       sx={{
        "&.MuiAutocomplete-root": {
          "& button[title='Clear']" : {
          visibility: 'visible'
        }}
      }}
       disableClearable={dataFormSearchFieldImportTransportation?.supplierId?.id ? false : true}
        id="supplierId"
        value={{id: dataFormSearchFieldImportTransportation?.supplierId?.id, descr: dataFormSearchFieldImportTransportation?.supplierId?.descr}}
       onChange={(event, value) => 
        {
          event.stopPropagation()
            setDataFormSearchFieldImportTransportation({ ...dataFormSearchFieldImportTransportation, supplierId: {...dataFormSearchFieldImportTransportation?.supplierId, id:value?.id ? value?.id : "", descr:value?.descr ? value?.descr: ""}});
          
         
        }}
             options={supplierArray.map((response:any)=> response)}
             getOptionLabel={(option:any) => option.descr}
       renderInput={(params:any) => <TextField variant="standard" fullWidth
        {...params} label={t("importTrasportation.filtersModal.selectSupplier")}  />}
        renderOption={(props, option, state) => {
          return (
            <li {...props} key={option.id}>
              {option.descr}
            </li>
          )
        }}
       />
                      
  
       </Box>
       
        <Box>
                <TextField
                  variant="standard"
                  fullWidth
                  id="filename"
                  name="filename"
                  label={t("importTrasportation.filtersModal.fileName")}
                  value={dataFormSearchFieldImportTransportation.fileName}
                  onChange={(event: any) => {
                    setDataFormSearchFieldImportTransportation({
                      ...dataFormSearchFieldImportTransportation,
                      fileName: event.target.value
                    });
                  }}
                  inputProps={{
                    pattern: "[^%*$\"+&?^~Â`£=!@'/§#]{0,}",
                    onInput: (event) => { 
                      
                      if (event.currentTarget.validity.patternMismatch) 
                     { event.currentTarget.setCustomValidity(t("vehicle.filterModal.regexMessage"))
                    }else {
                      event.currentTarget.setCustomValidity('')
                    }
                    }
                  }}
                />
              </Box>
              <Box>
                <DateTimePicker
                  label={t("importTrasportation.filtersModal.startDate")}
                  value={dataFormSearchFieldImportTransportation.startDateFrom}
                  onChange={(e: any) => {
                    setDataFormSearchFieldImportTransportation({
                      ...dataFormSearchFieldImportTransportation,
                      startDateFrom: e,
                    })
                  }}
                  mask={"__/__/____ __:__"}
                  inputFormat={"DD/MM/YYYY HH:mm"}
                  ampm={false}
                  renderInput={(params: any) => (
                    <TextField
                      variant="standard"
                      fullWidth
                      {...params}
                      name="startDateTo"
                    />
                  )}
                />
              </Box>
              <Box>
                <DateTimePicker
                  label={t("importTrasportation.filtersModal.endDate")}
                  value={dataFormSearchFieldImportTransportation.startDateTo}
                  onChange={(e: any) => {
                    
                      setDataFormSearchFieldImportTransportation({
                      ...dataFormSearchFieldImportTransportation,
                      startDateTo: e
                    })
                 
                  }
                  }
                  mask={"__/__/____ __:__"}
                  inputFormat={"DD/MM/YYYY HH:mm"}
                  ampm={false}
                  renderInput={(params: any) => (
                    <TextField
                      variant="standard"
                      fullWidth
                      {...params}
                      name="startDateTo"
                    />
                  )}
                />
              </Box>
              <Box>
      
       
                 
       <Autocomplete
       disablePortal
       sx={{
        "&.MuiAutocomplete-root": {
          "& button[title='Clear']" : {
          visibility: 'visible'
        }}
      }}
       disableClearable={dataFormSearchFieldImportTransportation?.status ? false : true}
       id="status"
        value={dataFormSearchFieldImportTransportation.status}
       onChange={(event, value) => 
      {
        event.stopPropagation()
        setDataFormSearchFieldImportTransportation({
          ...dataFormSearchFieldImportTransportation,
          status: value ? value : ""
        });
      }}
             options={statusArray.map((response:any)=> response)}
             getOptionLabel={(option:any) => changeStatusName(option)}
       renderInput={(params:any) => <TextField variant="standard" fullWidth
        {...params} label={t("importTrasportation.filtersModal.selectStatus")}  />}
        renderOption={(props, option, state) => {
          return (
            <li {...props} key={props.id}>
              {changeStatusName(option)}
            </li>
          )
        }}
       />
                      
  
       </Box>
        </GenericFilterBox>

      </form>
    </>
  );
};
